import { updateItems } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            最新动态
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            51影院每日更新动态，不错过任何精彩内容
          </p>
        </div>
        <div className="relative">
          <div className="absolute left-[19px] md:left-[23px] top-0 bottom-0 w-px bg-background-300"></div>
          <div className="space-y-0">
            {updateItems.map((item, idx) => (
              <div key={idx} className="relative flex items-start gap-4 md:gap-5 pb-6 md:pb-8 last:pb-0 pl-10 md:pl-12">
                <span className="absolute left-0 top-0 w-[10px] h-[10px] md:w-[12px] md:h-[12px] rounded-full bg-primary-500 ring-4 ring-background-100 mt-1.5"></span>
                <span className="flex-shrink-0 text-xs font-medium text-foreground-500 whitespace-nowrap mt-0.5">
                  {item.date}
                </span>
                <div className="flex-1 min-w-0">
                  <p className="text-sm md:text-base text-foreground-800 leading-relaxed">
                    {item.title}
                  </p>
                </div>
                <span className="flex-shrink-0 px-2 py-0.5 rounded-full text-xs font-medium bg-accent-100 text-accent-600 whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}